import Vue from 'vue'
import { encrypt, decrypt, AESencrypt, AESdecrypt, AESOBJencrypt, AESOBJdecrypt } from './index.js'

// Vue.prototype.$encrypt = encrypt
// Vue.prototype.$decrypt = decrypt
Vue.prototype.$aes = { encrypt, decrypt, AESencrypt, AESdecrypt, AESOBJencrypt, AESOBJdecrypt }
